import React from 'react'
import { FulfillmentDisplay } from '../FulfillmentDisplay/FulfillmentDisplay'
import { useModeHistoryPushCallback } from '../ModeRouter/ModeRouter'

export const FulfillmentSelector: React.FC = () => {
  const navToFulfillment = useModeHistoryPushCallback({
    mode: 'fulfillment'
  })

  return (
    <FulfillmentDisplay
      inline
      showDeliveryAddress={true}
      showPickupAddress={true}
      editButtonTestId='edit-fulfillment'
      editButtonProps={{
        className: 'cursor-pointer',
        id: 'edit-fulfillment',
        onClick: navToFulfillment,
        type: 'button'
      }}
    />
  )
}
